module.exports = {
  blogPostDir: 'posts', // The name of directory that contains your posts.
  contentPageDir: 'pages',
  siteTitle: 'AppTree Enterprise', // Site title.
  siteTitleAlt: 'AppTree Revolution Software', // Alternative site title for SEO.
  siteLogo: '/logos/logo-1024.png', // Logo used for SEO and manifest.
  siteUrl: 'https://apptreesoftware.com', // Domain of your website without pathPrefix.
  pathPrefix: '/apptree', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription: 'The digital home of AppTree Revolution Software', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  siteFBAppID: '', // FB Application ID for using app insights
  googleAnalyticsID: 'UA-38810969-11', // GA tracking ID.
  disqusShortname: '', // Disqus shortname.
  postDefaultCategoryID: 'AppTree', // Default category for posts.
  userName: 'Eric Windmill', // Username to display in the author segment.
  userTwitter: 'https://twitter.com/ericwindmill?lang=en', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Portland, OR, USA', // User location to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  userLinks: {
    github: 'https://github.com/apptreesoftware',
    twitter: 'https://twitter.com/ericwindmill?lang=en',
    email: 'mailto:info@apptreesoftware.com'
  },
  copyright: '© 2018 AppTree Revolution', // Copyright string for the footer of the website and RSS feed.
  siteCredit: 'Eric Windmill', // I made the site
  themeColor: '#c62828', // Used for setting manifest and progress theme colors.
  backgroundColor: '#e0e0e0' // Used for setting manifest background color.
}



// WEBPACK FOOTER //
// ./data/SiteConfig.js